/** Zustand meta-data state for the page */

import type { IconName } from '@tunasong/icons'
import { create } from 'zustand'

/** Global state. We want to render `formDialog` on top (app) level */
export const usePageMetadata = create<{
  name: string
  description: string
  pageIconName: IconName
  setName: (pageName: string) => void
  setDescription: (pageDescription: string) => void
  setPageIconName: (pageIconName: IconName) => void
}>(set => ({
  name: 'Tunasong',
  description: 'Tunasong - Human musical creativity in the age of AI',
  pageIconName: 'Page',
  setName: (pageName: string) => set({ name: pageName }),
  setDescription: (pageDescription: string) => set({ description: pageDescription }),
  setPageIconName: (pageIconName: IconName) => set({ pageIconName }),
}))
